import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@app/state";
import { selectGroupsDirInfo } from "@app/state";
import DataGrid from "devextreme-react/data-grid";
import "./orgforms.scss";
// we create a grid with the directory information for the selected group
// the dir_types are the values of the keys in the "directories" store
export const DirInfo = () => {
  const { t } = useTranslation();
  const dirInfo = useAppSelector(selectGroupsDirInfo);

  return (
    <div id="su-dirinfo-form">
      <DataGrid key={"SD_ID"} dataSource={dirInfo} />
    </div>
  );
};
